import styles from '@/styles/forms.module.scss';

/**
 * FormField — подписанное поле формы (email, телефон).
 */
export default function FormField({ id, label, type = 'text', placeholder, value, onChange, error }) {
  return (
    <div className={styles.field}>
      {label && <label className={styles.label} htmlFor={id}>{label}</label>}
      <input
        id={id}
        className={[styles.input, error ? styles.error : ''].filter(Boolean).join(' ')}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        autoComplete={type === 'email' ? 'email' : type === 'tel' ? 'tel' : 'off'}
      />
      {error && <span className={styles.errorMsg}>{error}</span>}
    </div>
  );
}
